import { useState } from 'react';
import { useNotify } from 'react-admin';

export const getStyle = (language, id) => {
  const display = language.id === id ? 'block' : 'none';
  return { display }
}

export const useServerValidation = () => {
  const [errors, setErrors] = useState({});
  const notify = useNotify();

  const onFailure = error => {
    if (error.body.fileUploadError) {
      notify('Error Uploading File. Please try later.');
      return;
    }
    const submitErrors = error.body && error.body.errors.reduce((a, b) => {
      return { ...a, [b.param]: b.msg };
    }, {});

    setErrors(submitErrors);
  };

  const resetField = field => {
    const newErrors = { ...errors };
    delete newErrors[field];

    setErrors(newErrors);
  };

  return { errors, onFailure, resetField };
};

export const useLanguageChange = (defaultLanguage) => {
  const [language, setLanguage] = useState(defaultLanguage);

  const onLanguageChange = (lang) => {
    setLanguage(lang);
  }

  return { language, onLanguageChange };
}

export const convertFileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
